import React, { Fragment, useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import RoomCard from './RoomCard';
import AddRoomCard from './AddRoomCard';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { gAPI_Rooms } from '../../../../../constants/APIs';

function AboutRooms({ propertyId, locale }) {
  const [roomDetail, setRoomDetail] = useState([]);
  const [loaded, setLoading] = useState(false);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Rooms}/${propertyId}?lang=${locale}`,
    })
      .then(res => {
        setRoomDetail(res.data);
        setLoading(true);
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  return (
    <Fragment>
      {loaded && (
        <Row>
          <Colxx xxs="12">
            <Row>
              {roomDetail &&
                roomDetail.rooms &&
                roomDetail.rooms.map((room, index) => (
                  <Colxx xxs="12" xs="6" lg="3" key={index}>
                    <RoomCard room={room} propertyId={propertyId} />
                  </Colxx>
                ))}
            </Row>
          </Colxx>
          <Colxx xxs="12">
            <AddRoomCard propertyId={propertyId} />
          </Colxx>
        </Row>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(AboutRooms));
